import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-uploadvcirclemedia',
  templateUrl: './uploadvcirclemedia.component.html',
  styleUrls: ['./uploadvcirclemedia.component.css']
})
export class UploadvcirclemediaComponent implements OnInit {
  mediaLink: string='';
  mediaTitle: string ='';
  moduleid;
  uploading: boolean;
  countdown: number = 10;
  constructor(private headerinfo: ComponentheaderService, private router: Router, private activatedroute: ActivatedRoute, private modulemanager: ModulemanagementService, 
    private toaster: ToastrService
  ) {
        
  }
  ngOnInit(): void {
    this.headerinfo.pageLoadingStarted(this);
    this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid);

    this.headerinfo.setHeaderDisplay(
      'Upload Vcircle Media',
      [
        { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
        { displaytext: 'Media Library', route: '/user/modulemedialibrary', params: { moduleid: this.moduleid } },
        { displaytext: 'Upload Vcircle Media', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
      ],
      []);
    this.headerinfo.pageLoadingDone(this);
  }
  
  submit(){
    this.headerinfo.pageLoadingStarted(this);
    if(this.mediaTitle.length <= 0 || this.mediaLink.length <= 0){
      this.toaster.error("All fields are mandatory!");
      return;
    }

    this.modulemanager.uploadRemoteMedia(this.mediaLink, this.moduleid, this.mediaTitle).toPromise()     
      .catch((e) => {
        this.headerinfo.pageLoadingDone(this);
        this.uploading = false;
        if (interval)
          clearInterval(interval);
        if(timeout)
          clearTimeout(timeout);

        this.toaster.error(e.message);        
      });
    
    this.uploading = true;
    let interval = setInterval(() => --this.countdown, 1000);

    let timeout = setTimeout(()=>{
      this.toaster.info("File download and processing has been initiated.")
      this.router.navigate(['/user/modulemedialibrary'], { queryParams: { moduleid: this.moduleid } });
    }, 10000);
  }

}
